import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../redux/selectors";
import { GenericButton } from "../../../components/buttons/customButtons";
import { GenericContainer } from "../../../components/containers/GenericContainer";
import { ADD_STATE, REMOVE_STATE } from "../../../redux/actions/generics/IndexedActions";
import { genericIndexedActions } from "../../../redux/actions/generics/GenericIndexedActions";
import { addonPriceService } from "../../../jwt/_services/configuration/addonPriceService";
import { addonPriceProvider } from "../../../providers/addonPriceProvider";
import { AddonPriceForm } from "./AddonPriceForm";

const AddonPriceSection = (props) => {
    const path = props.path + "/prices";

    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject, app } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const formRef = useRef(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);

    useEffect(() => {
        if (!domainObject) return;

        const dataRequest = {
            item:{
                addon: { id: domainObject?.id },
            }
        };

        genericIndexedActions.search(path, addonPriceService, 0, 1000, dataRequest);
    }, [domainObject]);

    // const onAdd = () => {
    //     const dataRequest = {
    //         addonPrice: { id: addonPriceId },
    //         addon: { id: domainObject?.id },
    //     };
    //
    //     genericIndexedActions.add(path, addonPriceService, dataRequest);
    // };

    const onCreate = () => {
        formRef.current.showModal(null, domainObject, app?.fbDataBase);
    };

    const onEdit = (_addonPrice) => {
        formRef.current.showModal(_addonPrice, domainObject, app?.fbDataBase);
    };

    const onRemove = (_addonPrice) => {

        genericIndexedActions.delete(path, addonPriceService, _addonPrice?.id);
    };

    const renderContent = (_option) => {
        return (
            <div key={_option?.id} className={"module-menu-item"}>
                <label className="module-menu-item-title">
                    <h3>{_option?.currency?.currency + " - " + _option?.price}</h3>
                </label>
                <div className="float-right">
                    <GenericButton
                        style={"table"}
                        toolTip={"Editar"}
                        icon={"fa-edit"}
                        permission={"edit"}
                        onClick={(_) => onEdit(_option)}
                    />
                    <GenericButton
                        style={"danger-secondary"}
                        toolTip={"Desvincular"}
                        icon={"fa-minus"}
                        permission={"delete"}
                        onClick={(_) => onRemove(_option)}
                    />
                </div>
            </div>
        );
    };

    return (
        <>
            <AddonPriceForm ref={formRef} path={path} />
            {/*GENERIC CONTAINER PRECIOS*/}
            <GenericContainer
                listItems={listDomainObjects || []}
                renderContent={renderContent}
                loading={loading}

                onCreateItem={onCreate}
            />
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(AddonPriceSection);
